<template>
	<div class="alert" :class="alertClass">
		<div class="row">
			<div class="col-10" v-html="text"></div>
			<div
				class="col-2 d-inline-flex justify-content-end align-items-start"
			>
				<a
					href="#"
					v-if="false == true"
					class="dismiss"
					@click.prevent="dismissMessage"
					>&times;</a
				>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Message",
	props: ["text", "type", "showCloseIcon"],
	components: {},
	computed: {
		alertClass() {
			return "alert-" + this.type;
		}
	},
	methods: {
		dismissMessage() {
			this.$store.dispatch("dismissMessage", this.text);
		}
	},
	mounted() {}
};
</script>